import {OutgoingMessage} from 'http';
import router from 'next/router';
import {IS_CLIENT_SIDE} from './shared/utils/constants';

export function redirectTo(
  path: string,
  res?: OutgoingMessage,
  /**
   * CSR 일 경우 replace 가 아닌 router.push 를 한다.
   * 이 옵션은 getInitialProps 에서 유용하다. next.js 구조상 CSR 로 들어오면 router change 이벤트가 getInitialProps 뒤에 들어오므로 뒤로가기 할 히스토리가 쌓이지 않는다. 부득이하게 push 를 통해 history 를 남겨야할 때 이 옵션을 사용하면 됨.
   */
  shouldPushInCsr?: boolean
) {
  if (res) {
    (res as any).writeHead(302, {
      Location: path,
    });
    res.end();
    res.finished = true;
  } else if (
    IS_CLIENT_SIDE &&
    (path.startsWith('/static') ||
      path.includes(`${window.location.host}/static`))
  ) {
    // 기본적으로 static 리소스는 '/static' 디렉토리를을, static 페이지를 위해서는 export 기능을 사용하도록 의도한 것으로 보임
    // next router를 통해 '/static' 아래 어떤 페이지로 이동하더라도, assetPrefix를 붙이고 일반 '/pages' 아래 페이지로 접근할 때와 동일한 동작을 함
    // 이를 회피하기위해 window.location.replace 메소드를 통해 SSR된 '/static' 아래 페이지로 접근할 수 있도록 수정
    window.location.replace(path);
  } else {
    IS_CLIENT_SIDE && shouldPushInCsr
      ? router.push(path)
      : router.replace(path);
  }
}
